import { render, staticRenderFns } from "./CardRemote.vue?vue&type=template&id=c4312bfc&scoped=true&"
import script from "./CardRemote.vue?vue&type=script&lang=js&"
export * from "./CardRemote.vue?vue&type=script&lang=js&"
import style0 from "./CardRemote.vue?vue&type=style&index=0&id=c4312bfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4312bfc",
  null
  
)

export default component.exports